import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api-dev.oshudstock.com';
const TOKEN_KEY = 'admin_session_token';

const api = axios.create({ baseURL: API_BASE });

// Attach token to every request automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
